module.exports = __webpack_public_path__ + "img/2.0d1e9a68.jpg";